import React from 'react';
import jwtDecode from 'jwt-decode';
import { Redirect } from 'react-router-dom';

export default (ComposedComponent) => {
  function RequireNotAuth(props) {
    //console.log('RequireNotAuth ->');
    const jwt = localStorage.getItem('jwt');
    //console.log(''+jwt);

    if (jwt) {
      const decoded = jwtDecode(jwt);
      //console.log(decoded);

      // if (!decoded.restaurant && location.pathname !== '/new-restaurant') {
      //   return (
      //     <Redirect to="/new-restaurant" />
      //   );
      // }

      // if (!decoded.id && !ignoreEmployeeLogin) {
      //   return (
      //     <Redirect to="/login-employee" />
      //   );
      // }

      return (
        <ComposedComponent {...props} />
      );
    }

    return (
      <React.Fragment>
        {!jwt ? <ComposedComponent {...props} /> : <Redirect to="/" />}
      </React.Fragment>
    );
  }

  return RequireNotAuth;
};
